"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _ui = require("@foundation-lib/ui");

var _core = require("@material-ui/core");

var _useFormContext2 = _interopRequireDefault(require("../../useFormContext"));

var SubmitButton = function SubmitButton(_ref) {
  var children = _ref.children,
      disabled = _ref.disabled,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["children", "disabled"]);

  var _useFormContext = (0, _useFormContext2["default"])(),
      isSubmitting = _useFormContext.isSubmitting;

  return /*#__PURE__*/_react["default"].createElement(_ui.Button, (0, _extends2["default"])({
    type: "submit"
  }, props, {
    disabled: isSubmitting || disabled
  }), isSubmitting ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.CircularProgress, {
    size: 15
  }), "\xA0\xA0") : '', children || 'Submit');
};

var _default = SubmitButton;
exports["default"] = _default;